import { __awaiter } from "tslib";
import Vue from 'vue';
import transfersHistoryAhead from './components/ahead/index.vue';
import moment from 'moment';
import services from '@/services';
import { nanoid } from 'nanoid';
export default Vue.extend({
    name: 'transfersPageTransfersHistory',
    data: () => ({
        loadError: false,
        isRetry: false,
        tables: {
            innerTransfers: {
                data: [],
                nextPage: null,
                isNextPageLoading: false
            },
            outerTransfers: {
                data: [],
                nextPage: null,
                isNextPageLoading: false
            },
            betweenExchangesTransfers: {
                data: [],
                nextPage: null,
                isNextPageLoading: false
            }
        },
        filters: {
            dateFrom: null,
            dateTo: null,
            asset: ''
        },
        initID: nanoid(8)
    }),
    props: {
        setRefreshAction: {
            // eslint-disable-next-line
            default: () => { },
            type: Function
        }
    },
    methods: {
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loadError = false;
                this.isRetry = true;
                this.initID = nanoid(8);
                const innerTransfersPromise = services.v2.transfers.getInnerTransfersHistory({ query: this.getFiltersQueryString(1) });
                const outerTransfersPromise = services.v2.transfers.getOuterTransfersHistory({ query: this.getFiltersQueryString(1) });
                const betweenExchangesPromise = services.mainService.getBetweenExchangesData({ query: this.getFiltersQueryString(1, true) });
                const [responseInnerTransfers, responseOuterTransfers, betweenExchangesResponse] = yield Promise.all([innerTransfersPromise, outerTransfersPromise, betweenExchangesPromise]);
                if (responseInnerTransfers.success && responseOuterTransfers.success) {
                    this.tables.innerTransfers.nextPage = responseInnerTransfers.data.payload.hasNext ? responseInnerTransfers.data.payload.nextPageNumber : null;
                    this.tables.outerTransfers.nextPage = responseOuterTransfers.data.payload.hasNext ? responseOuterTransfers.data.payload.nextPageNumber : null;
                    this.tables.betweenExchangesTransfers.nextPage = betweenExchangesResponse.data.hasNext ? betweenExchangesResponse.data.nextPageNumber : null;
                    this.tables.innerTransfers.data = responseInnerTransfers.data.payload.data.map(this.makeInnerTableItemFromResponseItem);
                    this.tables.outerTransfers.data = responseOuterTransfers.data.payload.data.map(this.makeOuterTableItemFromResponseItem);
                    this.tables.betweenExchangesTransfers.data = betweenExchangesResponse.data.data;
                }
                else {
                    this.loadError = true;
                }
                this.isRetry = false;
            });
        },
        makeInnerTableItemFromResponseItem(item) {
            return {
                inboundTransfersAccount: item.fromWallet === 'spot' ? this.$t('transfersPage.history.innerTable.futures') : this.$t('transfersPage.history.innerTable.spot'),
                datetime: moment(item.createdAt).format('DD.MM.YYYY HH:mm'),
                amount: item.amount,
                asset: item.asset,
                actions: ''
            };
        },
        makeOuterTableItemFromResponseItem(item) {
            return {
                recipient: item.bluredWallet,
                datetime: moment(item.createdAt).format('DD.MM.YYYY HH:mm'),
                amount: item.amount,
                asset: item.asset,
                network: item.network,
                status: item.status,
                isBlured: item.bluredWallet.includes('/'),
                actions: '',
                link: item.link
            };
        },
        getFiltersQueryString(page, isOther = false) {
            const query = new URLSearchParams();
            query.set('page', page.toString());
            if (this.filters.dateFrom && this.filters.dateTo) {
                const dateFromString = moment(this.filters.dateFrom).startOf('day').toISOString();
                const dateToString = moment(this.filters.dateTo).endOf('day').toISOString();
                query.set(isOther ? 'created_at__gte' : 'created_at_after', dateFromString);
                query.set(isOther ? 'created_at__lte' : 'created_at_before', dateToString);
            }
            if (this.filters.asset.length > 0) {
                query.set('asset', this.filters.asset);
            }
            return '?' + query.toString();
        },
        onNextPage() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isRetry || this.loadError) {
                    return;
                }
                const initID = this.initID;
                switch (this.$route.name) {
                    case 'innerTransfers': {
                        if (this.tables.innerTransfers.isNextPageLoading || !this.tables.innerTransfers.nextPage) {
                            return;
                        }
                        this.tables.innerTransfers.isNextPageLoading = true;
                        const nextPage = this.tables.innerTransfers.nextPage;
                        const response = yield services.v2.transfers.getInnerTransfersHistory({ query: this.getFiltersQueryString(nextPage) });
                        if (initID !== this.initID) {
                            return;
                        }
                        this.tables.innerTransfers.nextPage = response.data.payload.hasNext ? response.data.payload.nextPageNumber : null;
                        this.tables.innerTransfers.data = [...this.tables.innerTransfers.data, ...response.data.payload.data.map(this.makeInnerTableItemFromResponseItem)];
                        this.tables.innerTransfers.isNextPageLoading = false;
                        break;
                    }
                    case 'outerTransfers': {
                        if (this.tables.outerTransfers.isNextPageLoading || !this.tables.outerTransfers.nextPage) {
                            return;
                        }
                        this.tables.outerTransfers.isNextPageLoading = true;
                        const nextPage = this.tables.outerTransfers.nextPage;
                        const response = yield services.v2.transfers.getOuterTransfersHistory({ query: this.getFiltersQueryString(nextPage) });
                        if (initID !== this.initID) {
                            return;
                        }
                        this.tables.outerTransfers.nextPage = response.data.payload.hasNext ? response.data.payload.nextPageNumber : null;
                        this.tables.outerTransfers.data = [...this.tables.outerTransfers.data, ...response.data.payload.data.map(this.makeOuterTableItemFromResponseItem)];
                        this.tables.outerTransfers.isNextPageLoading = false;
                        break;
                    }
                    case 'betweenExchangesTransfers': {
                        if (this.tables.betweenExchangesTransfers.isNextPageLoading || !this.tables.betweenExchangesTransfers.nextPage) {
                            return;
                        }
                        this.tables.betweenExchangesTransfers.isNextPageLoading = true;
                        const nextPage = this.tables.betweenExchangesTransfers.nextPage;
                        const response = yield services.mainService.getBetweenExchangesData({ query: this.getFiltersQueryString(nextPage, true) });
                        if (initID !== this.initID) {
                            return;
                        }
                        this.tables.betweenExchangesTransfers.nextPage = response.data.hasNext ? response.data.nextPageNumber : null;
                        this.tables.betweenExchangesTransfers.data = [...this.tables.betweenExchangesTransfers.data, ...response.data.data];
                        this.tables.betweenExchangesTransfers.isNextPageLoading = false;
                        break;
                    }
                }
            });
        },
        onHistoryTypeChange(type) {
            const vm = this;
            if (type !== vm.$route.name) {
                vm.$router.replace({ name: type });
            }
        },
        clearFilters() {
            this.filters.dateFrom = null;
            this.filters.dateTo = null;
            this.filters.asset = '';
            this.init();
        },
        onAssetChange(asset) {
            this.filters.asset = asset;
            this.init();
        },
        onDateChange({ dateFrom, dateTo }) {
            if (this.dateFrom === dateFrom && this.dateTo === dateTo)
                return;
            this.filters.dateFrom = dateFrom;
            this.filters.dateTo = dateTo;
            this.init();
        },
        onRetry() {
            this.clearFilters();
            this.init();
        }
    },
    created() {
        const vm = this;
        vm.init();
        vm.setRefreshAction(() => {
            vm.init();
        });
    },
    components: {
        transfersHistoryAhead
    }
});
